import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { DeleteIconButton } from 'shared/mui/IconButtons';
import { Link } from 'shared/mui/Link/Link';
import { Typography } from 'shared/mui/Typography';
import {
  BoxWrapperStyled,
  ContentStyled,
} from 'shared/react-admin/Inputs/FileInput/FileInputPlaceholder/FileInputPlaceholder.styled';

type FileInputPlaceholderProps = {
  name: string;
  onDelete?: () => void;
};

export const FileInputPlaceholder = ({ name, onDelete }: FileInputPlaceholderProps) => {
  return (
    <BoxWrapperStyled>
      <ContentStyled>
        <InsertDriveFileOutlinedIcon color="secondary" />
        <Typography variant="body2">
          <Link>{name}</Link>
        </Typography>
      </ContentStyled>
      {onDelete && <DeleteIconButton onClick={onDelete} />}
    </BoxWrapperStyled>
  );
};
